import {
  SET_AIS_GAME_NAMES,
  SET_AIS_GAME_IMAGES,
  SET_AIS_GAME_POLA,
  SET_GAME_ISLOADING,
  SET_GAME_ISERROR
} from '../actionTypes';

const initialState = {
  aisNames: [],
  aisImages: [],
  aisPolas: [],
  nameAndImagesIsLoading: true,
  isError: null
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_AIS_GAME_NAMES:
      return { ...state, aisNames: action.payload }
    case SET_AIS_GAME_IMAGES:
      return { ...state, aisImages: action.payload };
    case SET_AIS_GAME_POLA:
      return { ...state, aisPolas: action.payload };
    case SET_GAME_ISLOADING:
      return { ...state, nameAndImagesIsLoading: action.payload };
    case SET_GAME_ISERROR:
      return { ...state, isError: action.payload };
    default:
      return state;
  };
};

export default reducer;